<template>
  <div>
    <!-- 企业服务 -->
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="enterprise">
      <yjh-sNav :titleList="titleArr" @myFn="navRoute"></yjh-sNav>
      <yjh-rlzy v-if="navIndex == 0"></yjh-rlzy>
      <yjh-rctd v-if="navIndex == 1"></yjh-rctd>
      <yjh-rpo v-if="navIndex == 2"></yjh-rpo>
      <yjh-sxfn v-if="navIndex == 3"></yjh-sxfn>
      <yjh-qygl v-if="navIndex == 4"></yjh-qygl>
      <yjh-bpo v-if="navIndex == 5"></yjh-bpo>
      <yjh-hzfs v-if="navIndex == 6"></yjh-hzfs>
    </div>
    <div class="mobile_enterprise">
      <div class="nav_item">
        <div
          class="nav_text"
          :class="{ active: 0 == mobileNavIndex }"
          @click="navClick_0"
        >
          人力资源系统开发
        </div>
        <div
          class="nav_text"
          :class="{ active: 2 == mobileNavIndex }"
          @click="navClick_2"
        >
          RPO招聘流程外包
        </div>
      </div>
      <div class="nav_item">
        <div
          class="nav_text"
          :class="{ active: 1 == mobileNavIndex }"
          @click="navClick_1"
        >
          人才梯队打造
        </div>
        <div
          class="nav_text"
          :class="{ active: 3 == mobileNavIndex }"
          @click="navClick_3"
        >
          实习赋能就业
        </div>
        <div
          class="nav_text"
          :class="{ active: 4 == mobileNavIndex }"
          @click="navClick_4"
        >
          企业管理咨询
        </div>
      </div>
      <div class="nav_item">
        <div
          class="nav_text"
          :class="{ active: 5 == mobileNavIndex }"
          @click="navClick_5"
        >
          BPO商业流程外包
        </div>
        <div
          class="nav_text"
          :class="{ active: 6 == mobileNavIndex }"
          @click="navClick_6"
        >
          合作方式
        </div>
      </div>
      <yjh-rlzy v-if="mobileNavIndex == 0"></yjh-rlzy>
      <yjh-rctd v-if="mobileNavIndex == 1"></yjh-rctd>
      <yjh-rpo v-if="mobileNavIndex == 2"></yjh-rpo>
      <yjh-sxfn v-if="mobileNavIndex == 3"></yjh-sxfn>
      <yjh-qygl v-if="mobileNavIndex == 4"></yjh-qygl>
      <yjh-bpo v-if="mobileNavIndex == 5"></yjh-bpo>
      <yjh-hzfs v-if="mobileNavIndex == 6"></yjh-hzfs>
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import sNav from "@/layouts/sNav";
import rlzy from "./component/rlzy";
import rctd from "./component/rctd";
import rpo from "./component/rpo";
import sxfn from "./component/sxfn";
import qygl from "./component/qygl";
import bpo from "./component/bpo";
import hzfs from "./component/hzfs";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
    "yjh-sNav": sNav,
    "yjh-rlzy": rlzy,
    "yjh-rctd": rctd,
    "yjh-rpo": rpo,
    "yjh-sxfn": sxfn,
    "yjh-qygl": qygl,
    "yjh-bpo": bpo,
    "yjh-hzfs": hzfs,
  },
  prpos: ["sNav", "header"],
  data() {
    return {
      idnex: "4",
      titleArr: [
        {
          id: 0,
          status: true,
          title: "人力资源系统开发",
          sTitle: "Human resource system development",
        },
        {
          id: 1,
          status: false,
          title: "人才梯队打造",
          sTitle: "Talent echelon building",
        },
        {
          id: 2,
          status: false,
          title: "RPO招聘流程外包",
          sTitle: "Human resource system development",
        },
        {
          id: 3,
          status: false,
          title: "实习赋能就业",
          sTitle: "Internships enable employment",
        },
        {
          id: 4,
          status: false,
          title: "企业管理咨询",
          sTitle: "Enterprise management consulting",
        },
        {
          id: 5,
          status: false,
          title: "BPO商业流程外包",
          sTitle: "BPO Business process outsourcing",
        },
        {
          id: 6,
          status: false,
          title: "合作方式",
          sTitle: "Method of cooperation",
        },
      ],
      navIndex: "0",
      mobileNavIndex: "0",
    };
  },
  created() {
    console.log(this.$route.query.navIndex);
    if (this.$route.query.navIndex == undefined) {
      this.navClick("0");
    } else {
      this.navClick(this.$route.query.navIndex);
    }
  },
  methods: {
    navClick_0() {
      this.mobileNavIndex = 0;
    },
    navClick_1() {
      this.mobileNavIndex = 1;
    },
    navClick_1() {
      this.mobileNavIndex = 1;
    },
    navClick_2() {
      this.mobileNavIndex = 2;
    },
    navClick_3() {
      this.mobileNavIndex = 3;
    },
    navClick_4() {
      this.mobileNavIndex = 4;
    },
    navClick_5() {
      this.mobileNavIndex = 5;
    },
    navClick_6() {
      this.mobileNavIndex = 6;
    },
    // 导航栏切换
    navClick(id) {
      this.navIndex = id;
      for (let i = 0; i < this.titleArr.length; i++) {
        this.titleArr[i].status = false;
      }
      this.titleArr[id].status = true;
    },
    // 导航栏路由
    navRoute(id) {
      this.$router.push({
        path: "/enterprise",
        query: {
          navIndex: id,
        },
      });
      this.navClick(id);
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 999px) {
  .enterprise {
    display: none;
  }
  .mobile_enterprise {
    .nav_item {
      display: flex;
      justify-content: space-around;
      .nav_text {
        padding: 5px 10px;
        border-radius: 10px;
        color: #ffffff;
        margin: 5px ;
        background: #7a7a78;
      }
      .active {
        background: #da261d;
      }
    }
  }

  // .nav_text:nth-child(1) {
  //   margin-left: 50px;
  // }
}
@media screen and (min-width: 1000px) {
  .mobile_enterprise {
    display: none;
  }
  .title {
    margin-top: 30px;
    font-size: 24px;
  }
  .s_nav {
    .itemBox {
      width: 100%;
    }
  }
}
</style>
